import React, { useState, useEffect } from 'react'
import '../css/Admin/AdminDashboard.css';
import Dash1 from '../assets/admin-dash1.png';
import { Pie } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import { useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import { MdOutlineNotificationImportant } from "react-icons/md";

Chart.register(ArcElement, Tooltip, Legend);
const AdminDashboard = ({setLoading, userData}) => {
const [classes, setClasses] = useState([]);
const [subjects, setSubjects] = useState([]);
const [emp, setEmp] = useState([]);
const navigate = useNavigate();
const [std, setStd] = useState([]);
 const currentYear = new Date().getFullYear();
 const currentMonthIndex = new Date().getMonth();
const [selectedFilterAY, setSelectedFilterAY] = useState(null);
 const [insNotice, setInsNotice] = useState([]);

 const [attendanceData, setAttendanceData] = useState({
    labels: ['Present', 'Absent', 'Leave', 'Holiday'],
    datasets: [
      {
        data: [0, 0, 0], // Default values
        backgroundColor: ['green', '#ef5350', 'orange', 'pink'],
        hoverBackgroundColor: ['darkgreen', '#f06361ff', '#FF9149', 'pink'],
        borderWidth: 1,
      },
    ],
  });


const searchableItems = [
  // General Settings
  { label: 'Profile', route: '/admin/profile' },
  { label: 'Academic Year', route: '/admin/academic-year' },
  { label: 'Account Detail', route: '/admin/account-detail' },

  // Classes
  { label: 'All Classes', route: '/admin/all-classes' },
  { label: 'New Class', route: '/admin/new-class' },

  // Subjects
  { label: 'Class Subjects', route: '/admin/class-subjects' },
  { label: 'Assign Subjects', route: '/admin/assign-subjects' },

  // Students
  { label: 'All Students', route: '/admin/all-students' },
  { label: 'Add Student', route: '/admin/add-student' },
  { label: 'Student I-Cards', route: '/admin/student-icards' },
  { label: 'Registrations', route: '/admin/registration-list' },

  // Employees
  { label: 'All Employees', route: '/admin/all-employees' },
  { label: 'Add Employee', route: '/admin/add-employee' },
  { label: 'Staff I-Cards', route: '/admin/staff-icards' },

  // Attendance
  { label: 'Students Attendance', route: '/admin/students-attendance' },
  { label: 'Employees Attendance', route: '/admin/employees-attendance' },
  { label: 'Students Attendance Report', route: '/admin/students-attendance-report' },
  { label: 'Employees Attendance Report', route: '/admin/employees-attendance-report' },

  // Time Table
  { label: 'Create Time Table', route: '/admin/create-time-table' },
  { label: 'Teacher Allocation', route: '/admin/teacher-allocation' },
  { label: 'Class Time Table', route: '/admin/class-time-table' },

  // Visits
  { label: 'Appointments', route: '/admin/appointments' },
  { label: 'Visits', route: '/admin/visits' },

  // Fees
  { label: 'Collect Fees', route: '/admin/collect-fees' },
  { label: 'Fees Reports', route: '/admin/fees-reports' },
  { label: 'Fee Particular', route: '/admin/fee-particular' },
  { label: 'Fee Structure', route: '/admin/fee-structure' },

  // Homework
  { label: 'Add Homework', route: '/admin/add-homework' },
  { label: 'Homework List', route: '/admin/homework-list' },
  { label: 'Homework Report', route: '/admin/homework-report' },

  // Study Material
  { label: 'Upload Content', route: '/admin/upload-content' },
  { label: 'Assignment', route: '/admin/assignment' },
  { label: 'Syllabus', route: '/admin/syllabus' },

  // Lesson Plan
  { label: 'Lessons', route: '/admin/lesson' },
  { label: 'Topics', route: '/admin/topic' },
  { label: 'Plan Overview', route: '/admin/plan-overview' },

  // Exam
  { label: 'Exam Type', route: '/admin/exam-type' },
  { label: 'Exam Setup', route: '/admin/exam-setup' },
  { label: 'Exam Schedule', route: '/admin/exam-schedule' },
  { label: 'Exam Attendance', route: '/admin/exam-attendance' },
  { label: 'Marks Entry', route: '/admin/offline-exam-report' },
  { label: 'Report Card', route: '/admin/offline-report-card' },

  // Online Exam
  { label: 'Question Group', route: '/admin/question-group' },
  { label: 'Question Bank', route: '/admin/question-bank' },
  { label: 'Create Exam', route: '/admin/create-exam' },

  // Leave
  { label: 'Apply Leave', route: '/admin/apply-leave' },
  { label: 'Approve Leave Request', route: '/admin/approve-leave-request' },
  { label: 'Leave Define', route: '/admin/leave-define' },

  // Library
  { label: 'Add Book', route: '/admin/add-book' },
  { label: 'Book List', route: '/admin/book-list' },
  { label: 'Add Member', route: '/admin/add-member' },
  { label: 'Issue/Return', route: '/admin/issue-return' },

  // Transport
  { label: 'Add Routes', route: '/admin/add-routes' },
  { label: 'Add Vehicle', route: '/admin/add-vehicle' },
  { label: 'Assign Vehicle', route: '/admin/assign-vehicle' },

  // Hostel
  { label: 'Add Hostel', route: '/admin/add-hostel' },
  { label: 'Room Type', route: '/admin/room-type' },
  { label: 'Hostel Rooms', route: '/admin/hostel-rooms' },
  { label: 'Assign Room', route: '/admin/assign-room' },
];


 const [empAttendanceData, setEmpAttendanceData] = useState({
    labels: ['Present', 'Absent', 'Leave', 'Holiday', 'Half Day'],
    datasets: [
      {
        data: [0, 0, 0], // Default values
        backgroundColor: ['green', '#ef5350', 'orange', 'pink', 'purple'],
        hoverBackgroundColor: ['darkgreen', '#f06361ff', '#FF9149', 'pink', 'purple'],
        borderWidth: 1,
      },
    ],
  });

    // Array of month names
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Get the current month name
    const currentMonthName = monthNames[currentMonthIndex];


    const fetchClasses = async () => {
                          setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-classes');
      
                      if (response.ok) {
                          const data = await response.json();
                          setClasses(data);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          console.error('Failed to fetch class');
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
    }


               const fetchSubjects = async () => {
                            setLoading(true);
                    try {
                        const response = await fetch('https://api.kcian.in/get-subjects');
        
                        if (response.ok) {
                            const data = await response.json();
                            setSubjects(data);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch class');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
      }

    const fetchEmp = async () => {
                          setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-employee');
      
                      if (response.ok) {
                          const data = await response.json();
 const filteredData = data.filter(emp => emp.id != userData.id);
                          setEmp(filteredData);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          console.error('Failed to fetch coupon');
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
    }


  const fetchStudent = async () => {

    setLoading(true);

    try {
      // Build query params
      const params = new URLSearchParams();
      params.append('ay', currentYear);

      const url = `https://api.kcian.in/get-student?${params.toString()}`;

      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        setStd(data);
      } else {
        console.error('Failed to fetch students');
      }
    } catch (error) {
      console.error('Error fetching students:', error);
    } finally {
      setLoading(false);
    }
  };


      const fetchAtd = async () => {
        setLoading(true);

        try {

            // Build query params
            const params = new URLSearchParams();
            params.append('ay', currentYear);
            params.append('month', currentMonthName);

            const url = `https://api.kcian.in/get-stdatd-report?${params.toString()}`;

            const response = await fetch(url);

            if (response.ok) {
                const data = await response.json();
               

 const present = data.filter((entry) => entry.mark === 'Present').length;
        const absent = data.filter((entry) => entry.mark === 'Absent').length;
        const leave = data.filter((entry) => entry.mark === 'Leave').length;
        // const holiday = data.filter((entry) => entry.mark === 'Holiday').length;
const holiday = [...new Set(data.filter(entry => entry.mark === 'Holiday').map(entry => entry.date))].length;

        // Set the attendance data for the pie chart
        setAttendanceData({
          labels: ['Present', 'Absent', 'Leave', 'Holiday'],
          datasets: [
            {
              data: [present, absent, leave, holiday],
              backgroundColor: ['green', '#ef5350', 'orange', 'pink'],
              hoverBackgroundColor: ['darkgreen', '#f06361ff', '#FF9149', 'pink'],
              borderWidth: 1,
            },
          ],
        });
                  } else {
                console.error('Failed to fetch students atd report');
            }
        } catch (error) {
            console.error('Error fetching students atd report:', error);
        } finally {
            setLoading(false);
        }
    };


    const fetchEmpAtd = async () => {
        setLoading(true);

        try {

            // Build query params
            const params = new URLSearchParams();
            params.append('ay', currentYear);
            params.append('month', currentMonthName);

            const url = `https://api.kcian.in/get-staffatd-report?${params.toString()}`;

            const response = await fetch(url);

            if (response.ok) {
                const data = await response.json();
                let filteredData;

if(userData.role == 'SupAdmin'){
  filteredData = data;
}
else {
                filteredData = data.filter(entry => entry.user_id === userData.user_id);
}

                 const present = filteredData.filter((entry) => entry.mark === 'Present').length;
        const absent = filteredData.filter((entry) => entry.mark === 'Absent').length;
        const leave = filteredData.filter((entry) => entry.mark === 'Leave').length;
const holiday = [...new Set(filteredData.filter(entry => entry.mark === 'Holiday').map(entry => entry.user_id))].length;
        const halfDay = filteredData.filter((entry) => entry.mark === 'Half Day').length;

        // Set the attendance data for the pie chart
        setEmpAttendanceData({
          labels: ['Present', 'Absent', 'Leave', 'Holiday', 'Half Day'],
          datasets: [
            {
              data: [present, absent, leave, holiday, halfDay],
              backgroundColor: ['green', '#ef5350', 'orange', 'pink', 'purple'],
              hoverBackgroundColor: ['darkgreen', '#f06361ff', '#FF9149', 'pink', 'purple'],
              borderWidth: 1,
            },
          ],
        });

            } else {
                console.error('Failed to fetch students atd report');
            }
        } catch (error) {
            console.error('Error fetching students atd report:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchClasses();
        fetchSubjects();
        fetchEmp();
        fetchStudent();
        fetchAtd();
        fetchEmpAtd();
    }, []);


  const attendanceOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          font: {
            size: 12,
          },
        },
      },
    },
  };


    const empAttendanceOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          font: {
            size: 12,
          },
        },
      },
    },
  };



const [searchTerm, setSearchTerm] = useState('');
const [filteredResults, setFilteredResults] = useState([]);

const handleSearch = (e) => {
  const value = e.target.value;
  setSearchTerm(value);
  if (value.length > 0) {
    const results = searchableItems.filter((item) =>
      item.label.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredResults(results);
  } else {
    setFilteredResults([]);
  }
};

const handleSelect = (route) => {
  navigate(route);
  setSearchTerm('');
  setFilteredResults([]);
};



const fetchNoticeList = async () => {
    setLoading(true);

    try {
        const url = `https://api.kcian.in/get-institute-notice?year=${currentYear}`;

        const response = await fetch(url);

        if (response.ok) {
            const data = await response.json();

    //              const currentDate = new Date();

    // const filteredData = data.filter((notice) => {
    //     const noticeDate = new Date(notice.title_date);

    //     return (
    //         noticeDate.getMonth() === currentDate.getMonth() &&
    //         noticeDate.getFullYear() === currentDate.getFullYear()
    //     );
    // });

            setInsNotice(data);
         
        } else {
            console.error('Failed to fetch');
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    } finally {
        setLoading(false);
    }
};

useEffect(() => {
    fetchNoticeList();
}, []);


const currentDate = new Date();
const currentMonth = currentDate.getMonth();


// Filter current month notices
const currentMonthNotices = insNotice.filter((notice) => {
    const noticeDate = new Date(notice.title_date);

    return (
        noticeDate.getMonth() === currentMonth &&
        noticeDate.getFullYear() === currentYear
    );
});

// Group by role
const roleWiseNotices = currentMonthNotices.filter(
  (notice) => notice.role === userData.role
);

  return (
    <>
      <section className='py-4'>
        <div className='px-4'>


{(userData.role == 'SupAdmin' || userData.role == 'Teacher') &&

<div className='row'>
<div className="col-12 mb-3">
  <div className="input-group">
    <span className="input-group-text"><FaSearch /></span>
    <input
      type="text"
      className="form-control"
      style={{border: 0, outline: 0, boxShadow: 'none'}}
      placeholder="Search Dashboard..."
      value={searchTerm}
      onChange={handleSearch}
    />
  </div>

  {filteredResults.length > 0 && (
    <ul className='bg-white rounded-bottom-4 py-3' style={{ maxHeight: '200px', overflowY: 'auto' }}>
      {filteredResults.map((item, index) => (
        <li
          key={index}
          className=" border-bottom text-muted py-2"
          style={{ cursor: 'pointer' }}
          onClick={() => handleSelect(item.route)}
        >
          {item.label}
        </li>
      ))}
    </ul>
  )}
</div>



<div className='col-lg-3 col-md-6 col-12 my-2'>
<div className='dash-card py-4' style={{backgroundColor: 'orange'}} onClick={() => {
    if (userData.role === 'SupAdmin') navigate('/admin/all-students');
  }}>
    <p className='fw-semibold'>Students AY {currentYear}</p>
    <p className='d-flex justify-content-between fs-5 fw-bold my-0'><i class="fa-regular fa-user"></i><span>{std.length}</span></p>
</div>
</div>

<div className='col-lg-3 col-md-6 col-12 my-2'>
<div className='dash-card py-4' style={{backgroundColor: 'pink'}} onClick={() => {if(userData.role == 'SupAdmin') navigate('/admin/all-employees')}}>
    <p className='fw-semibold'>Total Staff</p>
    <p className='d-flex justify-content-between fs-5 fw-bold my-0'><i class="fa-solid fa-briefcase"></i><span>{emp.length}</span></p>
</div>    
</div>

<div className='col-lg-3 col-md-6 col-12 my-2'>
    <div className='dash-card py-4' style={{backgroundColor: 'var(--ins2)'}} onClick={() => {if(userData.role == 'SupAdmin') navigate('/admin/all-classes')}}>
    <p className='fw-semibold'>Total Classes</p>
    <p className='d-flex justify-content-between fs-5 fw-bold my-0'><i class="fa-solid fa-pen-ruler"></i><span>{classes.length}</span></p>
</div>
</div>

<div className='col-lg-3 col-md-6 col-12 my-2'>
    <div className='dash-card py-4' style={{backgroundColor: 'var(--ins1)'}} onClick={() => {if(userData.role == 'SupAdmin') navigate('/admin/class-subjects')}}>
    <p className='fw-semibold'>Subjects Added</p>
    <p className='d-flex justify-content-between fs-5 fw-bold my-0'><i class="fa-solid fa-book-open"></i><span>{subjects.length}</span></p>
</div>
</div>


</div>
}

{/* row ends */}


        </div>
      </section>


<section>
    <div className='px-4'>

<div className='row'>

<div className='col-lg-4 col-12 my-2'>
                 <div
    className='alert alert-warning fw-semibold' style={{height: '18em'}}><p>
      Welcome to {userData.role == 'SupAdmin' ? 'Admin' : userData.role} Dashboard!<br /><br /><span className='para-text text-dark fw-normal'>Warm Regards. Software made available to Teachers/ Staffs for handy & convenient use.</span></p>
   <div className='text-center'><img src={Dash1} className='img-fluid' style={{height: '6em'}} /></div>
    </div>
</div>

{( userData.role == 'Teacher' || userData.role == 'Librarian' || userData.role == 'Transport' ) &&
<>
<div className="col-lg-4 col-12 my-2">
  <div
    className="alert alert-danger"
    style={{
      minHeight: "18em",
      overflowY: "auto"
    }}
  >
    <h5 className="fw-bold mb-3">
     <MdOutlineNotificationImportant />Notice Board
    </h5>

    {roleWiseNotices.length > 0 ? (
      roleWiseNotices.map((notice) => (
        <div
          key={notice.id}
          className="bg-white rounded p-2 mb-2 shadow-sm"
        >
          <h6 className=" text-danger mb-1">
            {notice.title}
          </h6>

          <p className="mb-1 text-dark small">
            {notice.description}
          </p>

          <small className="text-muted">
            {notice.title_date}
          </small>
        </div>
      ))
    ) : (
      <div className="text-center text-muted mt-4">
        No notices available
      </div>
    )}
  </div>
</div>
</>
}


<div className='col-lg-4 col-12 my-2 d-flex justify-content-center align-items-center'>
              <div className='alert cursor-pointer alert-light w-100 pb-5' style={{height: '18em'}} onClick={() => navigate('/admin/employees-attendance-report')}>
                <p className='fm-poppins fw-semibold'>{currentMonthName}'s {userData.role == 'SupAdmin' ? 'Employee' : userData.name} Attendance</p>
                <Pie data={empAttendanceData} options={empAttendanceOptions} height={80} width={80} />
              </div>
</div>

{(userData.role == 'SupAdmin' || userData.role == 'Teacher') &&

<div className='col-lg-4 col-12 my-2 d-flex justify-content-center align-items-center'>
              <div className='alert cursor-pointer alert-info w-100 pb-5' style={{height: '18em'}} onClick={() => navigate('/admin/students-attendance-report')}>
                <p className='fm-poppins fw-semibold'>{currentMonthName}'s Student Attendance</p>
                <Pie data={attendanceData} options={attendanceOptions} height={80} width={80} />
              </div>
</div>
}


{(userData.role == 'SupAdmin') &&
<>

<div className='col-lg-4 text-light'>
<p className='bg-warning px-3 py-3 cursor-pointer rounded-3 fw-bold' onClick={() => navigate('/admin/notice-board')}>Add Notice<br />
<p className='fw-normal mb-0 mt-3'>"Create and share important updates with students and staff easily."</p></p>

<p className='bg-danger px-3 py-3 cursor-pointer rounded-3 fw-bold' onClick={() => navigate('/admin/grievances')}>List Complaint<br />
<p className='fw-normal mb-0 mt-3'>"View and manage all complaints in one place efficiently."</p></p>

</div>


<div className='col-lg-4 text-light'>
<p className='bg-info px-3 py-3 cursor-pointer rounded-3 fw-bold' onClick={() => navigate('/admin/issue-return')}>Library Panel<br />
</p>

<p className='bg-secondary px-3 py-3 cursor-pointer rounded-3 fw-bold' onClick={() => navigate('/admin/transport-report')}>Transport Panel<br />
</p>

<p className='bg-success px-3 py-3 cursor-pointer rounded-3 fw-bold' onClick={() => navigate('/admin/hostel-report')}>Hostel Panel<br />
</p>

</div>


<div className='col-lg-4 text-light'>
<p className='bg-primary px-3 py-3 cursor-pointer rounded-3 fw-bold' onClick={() => navigate('/admin/exam-setup')}>Exam Setup<br />
<p className='fw-normal mb-0 mt-3'>"Organize, schedule, and manage exams effortlessly for all classes."</p></p>

<p className='bg-dark px-3 py-3 cursor-pointer rounded-3 fw-bold' onClick={() => navigate('/admin/create-exam')}>Online Exam<br />
<p className='fw-normal mb-0 mt-3'>"Conduct, monitor, and review online assessments with complete control."</p></p>

</div>



</>
}
 




</div>
{/* row ends */}





    </div>
</section>



    </>
  )
}

export default AdminDashboard
